import React from "react";
import DirectusCombobox from "./combobox";
import EvtMultiSelectBadges from "../multiselect";
import client from "directus/src/client";
import FilterWrapper from "components/filter/wrapper";

export default function DepartmentCombobox({
  filter = { status: { _eq: 'published' } },
  hideLabel,
  className,
  multiselect = false,
  ...props
}) {
  // If multiselect is enabled, use the multiselect component
  if (multiselect) {
    if (hideLabel) {
      return (
        <div className={className}>
          <EvtMultiSelectBadges
            collection="departments"
            fields={["id", "name"]}
            searchKeys={["name"]}
            filter={{ ...(filter || {}), status: { _eq: 'published' } }}
            placeholder="Select"
            {...props}
          />
        </div>
      );
    }

    return (
      <FilterWrapper label="Department" className={className}>
        <EvtMultiSelectBadges
          collection="departments"
          fields={["id", "name"]}
          searchKeys={["name"]}
          filter={{ ...(filter || {}), status: { _eq: 'published' } }}
          placeholder="Select"
          {...props}
        />
      </FilterWrapper>
    );
  }

  // Default single select behavior
  if (hideLabel) {
    return (
      <div className={className}>
        <DirectusCombobox
          client={client}
          collection="departments"
          fields={["id", "name"]}
          searchKeys={["name"]}
          filter={filter}
          placeholder="Select Department"
          {...props}
        />
      </div>
    );
  }

  return (
    <FilterWrapper
      label="Department"
      className={className}
      required={props?.required}
    >
      <DirectusCombobox
        client={client}
        collection="departments"
        fields={["id", "name"]}
        searchKeys={["name"]}
        filter={filter}
        limit={-1}
        {...props}
      />
    </FilterWrapper>
  );
}
